<template>
  <div class="new-push-dialog">
    <v-dialog title="Create Push" :visible.sync="dialogVisible" width="60vw" @open="onOpen" @closed="onClosed">
      <el-form ref="form" :model="form" :rules="formRules" label-position="top">
        <el-row class="greetings-settings" :gutter="30" type="flex">
          <el-col :span="12" class="greetings">
            <h4>Greetings</h4>
            <el-form-item label=" " class="push-to-msl" prop="pushToMSL" v-role="[2, 3, 5, 7, 9, 11,13]">
              <el-checkbox v-model="form.pushToMSL" :disabled="disablePushToMSL">Push to Me</el-checkbox>
              <el-button v-if="disablePushToMSL" class="bind-wechat-link" type="text" @click="bindWeChat()">
                Bind WeChat?
              </el-button>
            </el-form-item>
            <el-form-item prop="seIds" :label="formItemLabel">
              <el-radio-group v-model="seType" @input="changeSeType" v-if="isSupervisor|| isMSL">
                <el-radio label="All">All</el-radio>
                <el-radio label="SE">SE</el-radio>
                <el-radio label="CE">CE</el-radio>
              </el-radio-group>
              <SEMultipleSelect v-model="form.seIds" :showTips="true" :placeholder="selectPlaceholder" :options="seListByType" :showTag="false"
                type='push'/>
            </el-form-item>
            <el-form-item prop="greeting" label="Greetings">
              <el-input v-model="form.greeting" placeholder="Please input greetings" maxlength="100">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="settings" :class="{ msl: notMSL }">
            <h4>Settings</h4>
            <div>
              <el-row type="flex" align="bottom" :gutter="20">
                <el-col>
                  <el-form-item prop="categoried" label="Categorized" class="cate">
                    <el-radio-group v-model="form.categoried" @change="onCateChange">
                      <el-radio v-for="cate in categories" :key="cate.key" :label="cate.key">
                        {{ cate.value }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item prop="scheduled">
                    <el-checkbox v-model="form.scheduled" @change="onScheduleChange" :true-label="1" :false-label="0">
                      Scheduled
                    </el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" align="bottom" :gutter="20">
                <el-col class="priority" :span="10">
                  <el-form-item label="Priority" prop="priority">
                    <el-select v-model="form.priority" placeholder="Please select priority">
                      <el-option v-for="p in priorities" :label="p.value" :value="p.key" :key="p.key" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="schedule-date" :span="14">
                  <template v-if="form.scheduled">
                    <el-form-item prop="scheduleDate" label="Schedule Date / Time">
                      <div class="datetime">
                        <el-date-picker v-model="sDate" type="date" :format="dateFormat" :value-format="dateFormat"
                          placeholder="Date" :editable="false" />
                        <el-select class="times-select" v-model="sTime" clearable allow-create filterable
                          placeholder="Time" @blur="onTimeBulr($event, 'sTime')" ref="sTime">
                          <i slot="prefix" class="el-input__icon el-icon-time"></i>
                          <el-option v-for="(item, i) in times" :key="i" :label="item.value" :value="item.value" />
                        </el-select>
                      </div>
                    </el-form-item>
                  </template>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row class="request-type" :gutter="30" type="flex">
          <el-col :span="12">
            <h4>Please Specify The Request(Choose One Request Type)</h4>
            <el-form-item prop="requestType" class="request-type">
              <el-radio-group v-model="form.requestType" @change="onRequestTypeChange">
                <div v-for="type in pushTypes" :key="type.key">
                  <el-radio :label="type.key" :key="type.key">{{ type.value }}</el-radio>
                    <template v-if="form.requestType === type.key && type.key === 0 && isVMSL">
                      <el-input v-model="form.requestContent" placeholder="Please input reason" />
                    </template>
                  <template v-if="form.requestType === type.key && type.key === 1">
                    <el-row type="flex" align="bottom" :gutter="20">
                      <el-col class="interaction-date-time">
                        <el-form-item prop="interactionDateTime" label="Interaction date/time">
                          <div class="datetime">
                            <el-date-picker v-model="iDate" type="date" :format="dateFormat" :value-format="dateFormat"
                              placeholder="Date" :editable="false" />
                            <el-select class="times-select" v-model="iTime" clearable allow-create filterable
                              placeholder="Time" @blur="onTimeBulr($event, 'iTime')" ref="iTime">
                              <i slot="prefix" class="el-input__icon el-icon-time"></i>
                              <el-option v-for="(item, i) in times" :key="i" :label="item.value" :value="item.value" />
                            </el-select>
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col class="interaction-type">
                        <el-form-item prop="interactionTypeId" label="Interaction type">
                          <el-select v-model="form.interactionTypeId" placeholder="Interaction type">
                            <el-option v-for="t in interTypes" :label="t.value" :value="t.key" :key="t.key" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item prop="requestContent" label="Request Content">
                      <el-input v-model="form.requestContent" type="textarea" rows="3" :maxlength="200" />
                    </el-form-item>
                  </template>
                  <template v-if="form.requestType === type.key && type.key === 6 && isVMSL">
                    <el-input v-model="form.requestContent" placeholder="Please input reason" />
                    <CheckboxGroup v-model="form.initActivities" class="activity_options">
                      <Checkbox v-for="activity in activityOptions" :key="activity.optionId" :label="activity.optionId">
                        {{ activity.optionValue }}
                      </Checkbox>
                    </CheckboxGroup>
                  </template>
                </div>
                <!-- <el-radio v-for="type in pushTypes" :label="type.key" :key="type.key" >
                  {{ type.value }}
                </el-radio> -->
              </el-radio-group>
            </el-form-item>
            <!-- <template v-if="form.requestType === 1">
              <el-row type="flex" align="bottom" :gutter="20">
                <el-col class="interaction-date-time">
                  <el-form-item prop="interactionDateTime" label="Interaction date/time">
                    <div class="datetime">
                      <el-date-picker v-model="iDate" type="date" :format="dateFormat" :value-format="dateFormat"
                        placeholder="Date" :editable="false" />
                      <el-select class="times-select" v-model="iTime" clearable allow-create filterable
                        placeholder="Time" @blur="onTimeBulr($event, 'iTime')" ref="iTime">
                        <i slot="prefix" class="el-input__icon el-icon-time"></i>
                        <el-option v-for="(item, i) in times" :key="i" :label="item.value" :value="item.value" />
                      </el-select>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col class="interaction-type">
                  <el-form-item prop="interactionTypeId" label="Interaction type">
                    <el-select v-model="form.interactionTypeId" placeholder="Interaction type">
                      <el-option v-for="t in interTypes" :label="t.value" :value="t.key" :key="t.key" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item prop="requestContent" label="Request Content">
                <el-input v-model="form.requestContent" type="textarea" rows="3" :maxlength="200" />
              </el-form-item>
            </template> -->
            <el-form-item class="select-content" prop="papers">
              <el-button type="danger" plain @click="showSelectDialog">
                Select Content
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-table v-if="form.categories.length > 0 && form.categoried === 1" class="cate-intro"
              :data="form.categories" max-height="310px">
              <el-table-column prop="categoryName" label="Category" width="130" />
              <el-table-column prop="introduction" label="Introduction">
                <template slot-scope="{ row }">
                  <el-input type="textarea" v-model="row.introduction" rows="1" autosize :maxlength="50" />
                </template>
              </el-table-column>
            </el-table>
            <div class="cate-intro" v-else></div>
          </el-col>
        </el-row>
      </el-form>
      <div class="table-wrapper" v-if="selectTableData.length > 0">
        <el-table :data="selectTableData" max-height="500px">
          <el-table-column prop="CategoryName" label="Category" min-width="120" />
          <el-table-column prop="ShortTitle" label="Short Title" min-width="130" />
          <el-table-column prop="DocumentTitle" label="Content Title" min-width="120" />
          <el-table-column prop="SearchTerm" label="Search Term" min-width="130" />
          <el-table-column prop="CreatedOn" label="Create Date" min-width="130" />
          <el-table-column label="Operation" align="center" width="120">
            <div class="operation-actions" slot-scope="{ $index, row }">
              <el-button type="text" icon="el-icon-top" @click="onMoveUp($index)" />
              <el-button type="text" icon="el-icon-bottom" @click="onMoveDown($index)" />
              <el-button type="text" icon="el-icon-delete" @click="onDeleteSelect($index, row.PaperCategoryID)" />
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit(1)" :disabled="actionDisabled">
          Submit
        </el-button>
        <el-button @click="submit(0)" :disabled="actionDisabled">
          Save Draft
        </el-button>
      </div>
    </v-dialog>
    <SelectContentDialog ref="selectContentDialog" :visible.sync="selectContentDialogVisible"
      :selected="selectTableData" :categoried="form.categoried" @select="onSelect" @closed="onSelectDialogClosed" />
  </div>
</template>
<script>
import SelectContentDialog from "../push/select-content-dialog";
import { getTimes } from "../../utils/datetime";
import { trimValidate } from "../../utils/validator";
import { RoleCode } from "@/utils/role-constant";
import SEMultipleSelect from "../../components/se-multiple-select";
import { CheckboxGroup, Checkbox } from 'element-ui';

export default {
  name: "NewPushDialog",
  components: {
    SEMultipleSelect,
    SelectContentDialog,
    CheckboxGroup,
    Checkbox
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    seId: String,
  },
  data() {
    const validatePapers = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("Please select content"));
      } else {
        callback();
      }
    };
    return {
      seType: 'All',
      dialogVisible: this.visible,
      dateFormat: "yyyy-MM-dd",
      timeFormat: "HH:mm",
      form: {
        pushToMSL: false,
        seIds: [],
        greeting: "",
        categoried: 0,
        priority: "",
        status: "", // 0 drafft  1 submit
        scheduled: 0,
        scheduleDate: null,
        requestType: "",
        meetingRequestType: null,
        interactionTypeId: null,
        interactionDateTime: null,
        requestContent: "",
        categories: [], // {categoryId:"",sequence:"",introduction:"",categoryName:""}
        papers: [], // {paperCateId:"",msgCateId:""}
        initActivities: [],
      },
      formRules: {
        seIds: {
          type: "array",
          required: true,
          message: "Please select HCP",
          tigger: "change",
        },
        greeting: [
          {
            required: true,
            validator: trimValidate("Please input greetings"),
            tigger: "blur",
          },
        ],
        papers: [
          {
            validator: validatePapers,
            tigger: "blur",
          },
        ],
        scheduleDate: [
          {
            required: false,
            message: "Please select schedule date and time",
            tigger: "change",
          },
        ],
        interactionDateTime: [
          {
            required: true,
            message: "Please select interaction date and time",
            tigger: "change",
          },
        ],
        interactionTypeId: [
          {
            required: true,
            message: "Please select interaction type",
            tigger: "change",
          },
        ],
        // requestContent: [
        //   {
        //     required: false,
        //     validator: trimValidate("Please input request content"),
        //     tigger: "blur",
        //   },
        // ],
      },
      hidePushDialog: false,
      selectTableData: [],
      selectContentDialogVisible: false,
      sDate: "",
      sTime: "",
      iDate: "", // interaction date
      iTime: "", // interaction time
      seList: [],
      categories: [],
      priorities: [],
      interTypes: [],
      pushTypes: [],
      activityOptions: [],
      actionDisabled: false,
    };
  },
  computed: {
    seListByType(){
      if(this.seType=='All') return this.seList
      return this.seList.filter(item=>item.types?item.types.includes(this.seType):'')
    },
    nameLabel() {
      const role = this.$store.state.role;
      return role === RoleCode.ML || role === RoleCode.Supervisor
        ? "HCP"
        : (role === RoleCode.VMSL?'vCE':"Customer");
    },
    formItemLabel() {
      return `Select ${this.nameLabel}`;
    },
    selectPlaceholder() {
      return `Please select ${this.nameLabel.toLowerCase()}`;
    },
    times() {
      return getTimes("00:00", "23:30", "00:30", "00:00", "23:30");
    },
    userInfo() {
      return this.$store.state.userInfo || {};
    },
    notMSL() {
      return (
        this.userInfo.role === RoleCode.Supervisor ||
        this.userInfo.role === RoleCode.ML ||
        this.userInfo.role === RoleCode.CRP ||
        this.userInfo.role === RoleCode.CVEO ||
        this.userInfo.role === RoleCode.SciCom ||
        this.userInfo.role === RoleCode.ClinTrans ||
        this.userInfo.role === RoleCode.VMSL
      );
    },
    disablePushToMSL() {
      return this.userInfo.bindStatus !== 2;
    },
    isBatchPush() {
      return this.form.seIds.length > 1;
    },
    seIds() {
      if (this.isBatchPush) {
        return `'${this.form.seIds.toString().replace(",", "','")}'`;
      }
      return this.form.seIds[0];
    },
    isSupervisor() {
      return this.$store.state.role === RoleCode.Supervisor
    },
    isMSL() {
      return this.$store.state.role === RoleCode.ML;
    },
    isVMSL() {
      return this.$store.state.role === RoleCode.VMSL;
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
    sDate(value) {
      this.form.scheduleDate =
        value && this.sTime ? `${value} ${this.sTime}` : "";
    },
    sTime(value) {
      this.form.scheduleDate =
        value && this.sDate ? `${this.sDate} ${value}` : "";
    },
    iDate(value) {
      this.form.interactionDateTime =
        value && this.iTime ? `${value} ${this.iTime}` : "";
    },
    iTime(value) {
      this.form.interactionDateTime =
        value && this.iDate ? `${this.iDate} ${value}` : "";
    },
    selectTableData(value) {
      this.form.papers = Array.from(value, (i, index) => {
        return {
          paperId: i.PaperID,
          shortTitle: i.ShortTitle,
          paperCateId: i.PaperCategoryID,
          sequence: index + 1,
        };
      });
    },
  },
  created() {
    this.formRules.seIds.message = this.selectPlaceholder;
  },
  methods: {
    changeSeType(){
      this.form.seIds = []
    },
    onClosed() {
      this.checkBindWeChatStatus();
      if (!this.hidePushDialog) {
        this.$refs['form'].resetFields();
        this.$refs.selectContentDialog.resetToFirstPage();
        this.$refs.form.resetFields();
        this.form.categories = [];
        this.form.papers = [];
        this.form.requestContent = '';
        this.form.initActivities = []
        // this.form.sch;
        this.sDate = "";
        this.sTime = "";
        this.iDate = "";
        this.iTime = "";
        this.seType = 'All'
        this.selectTableData = [];
        this.formRules.scheduleDate[0].required = false;
        this.formRules.interactionDateTime[0].required = false;
        this.formRules.interactionTypeId[0].required = false;
        // this.formRules.requestContent[0].required = false;
        this.actionDisabled = false;
        this.$emit("update:visible", false);
      }
    },
    onOpen() {
      this.checkBindWeChatStatus();
      this.$axios
        .all([this.axios.get("/push/seList"), this.axios.get("/push/param")])
        .then((res) => {
          this.handleSEResp(res[0]);
          this.handleParamsResp(res[1]);
          this.hidePushDialog = false;
        });
      if (!this.isVMSL) {
        this.formRules.requestContent = [
          {
            required: true,
            validator: trimValidate('Please input request content'),
            trigger: 'blur',
          },
        ]
      }
    },
    handleSEResp({ code, data }) {
      if (code === 200) {
        this.seList = data.map((item) => ({
          ...item,
          Certified: true,
          disabled: false,
        }));
        if (!this.hidePushDialog) {
          if (data.length > 0) {
            const result = this.seList.filter(item => item.SEID === this.seId);
            let seIds =[]
            if(this.seId && result.length>0){
              //如果打开有带入的seId并且当前用户的selist有他，回显。否则清空，不然会出现uuid的情况
                seIds = [this.seId]
            }
            this.form.seIds = seIds
            // this.form.seIds = this.seId ? [this.seId] : [];
          }
        }
      }
    },
    handleParamsResp({ code, data }) {
      if (code === 200) {
        this.categories = data.categoried;
        this.priorities = data.priority;
        this.pushTypes = data.pushType;
        this.activityOptions = data.initActivitiesParams;
        this.interTypes = data.interType;
        if (!this.hidePushDialog) {
          this.form.requestType =
            data.pushType.length > 0 ? data.pushType[0].key : "";
          this.form.categoried =
            data.categoried.length > 0 ? data.categoried[0].key : "";
          this.form.priority =
            data.priority.length > 0 ? data.priority[0].key : "";
          this.form.interactionTypeId =
            data.interType.length > 0 ? data.interType[0].key : "";
        }
      }
    },
    bindWeChat() {
      this.bus.$emit("bindWeChat");
    },
    checkBindWeChatStatus() {
      this.axios
        .get("/user/bind", {
          headers: {
            showLoading: false,
          },
        })
        .then(({ code, data }) => {
          if (code === 200 && data) {
            const bindStatus = data.bindStatus;
            this.$store.commit("updateState", {
              userInfo: {
                ...this.userInfo,
                bindStatus,
              },
            });
          }
        });
    },
    setTimeInputListener(ref) {
      this.$nextTick(() => {
        // const timeDom = this.$refs[ref];
        let refsData = this.$refs[ref];
        const timeDom = Array.isArray(refsData) ? refsData[0] : refsData;
        if (timeDom) {
          const input = timeDom.$refs.reference;
          input.$on("input", (value) => {
            value = value.length > 5 ? value.substring(0, 5) : value;
            value = value.replace(/[^0-9:\uff1a]/g, "").replace(/\uff1a/g, ":");
            timeDom.$set(timeDom, "selectedLabel", value);
          });
        }
      });
    },
    onTimeBulr(e, ref) {
      let timeDom = this.$refs[ref];
      if (timeDom) {
        const reg = /([01]?[0-9]|2[0-3]):[0-5][0-9]/;
        if (timeDom.selectedLabel) {
          if (reg.test(timeDom.selectedLabel)) {
            this.$set(this, ref, timeDom.selectedLabel);
          } else {
            timeDom.deleteSelected(e);
          }
        }
      }
    },
    onCateChange(value) {
      // this.selectTableData = [];
      if (value === 0) {
        // this.form.categories = [];
      } else {
        this.handleCategories();
      }
    },
    onScheduleChange(value) {
      this.formRules.scheduleDate[0].required = value;
      if (!value) {
        this.sDate = "";
        this.sTime = "";
      }
      if (value) {
        this.setTimeInputListener("sTime");
      }
    },
    onRequestTypeChange(value) {
      this.formRules.interactionDateTime[0].required = value === 1;
      this.formRules.interactionTypeId[0].required = value === 1;
      // this.formRules.requestContent[0].required = false;
      this.form.requestContent = "";
      this.form.initActivities = [];
      if (value === 0 || value === 6) {
        this.iDate = "";
        this.iTime = "";
        this.form.interactionTypeId = null;
      }
      if (value === 1) {
        this.setTimeInputListener("iTime");
      }
    },
    handleCategories() {
      let cates = {};
      this.selectTableData.forEach((item, i) => {
        if (!cates[item.PaperCategoryID]) {
          cates[item.PaperCategoryID] = {
            categoryId: item.PaperCategoryID,
            categoryName: item.CategoryName,
            sequence: i + 1,
            introduction: "",
          };
        }
      });
      let _cates = Object.values(cates);
      let newCates = _cates.filter((i) => {
        return !this.form.categories.some((j) => j.categoryId === i.categoryId);
      });
      let categories = this.form.categories.concat(newCates);
      this.$set(this.form, "categories", categories);
    },
    showSelectDialog() {
      this.hidePushDialog = true;
      this.dialogVisible = false;
      this.selectContentDialogVisible = true;
    },
    onSelectDialogClosed() {
      this.dialogVisible = true;
    },
    onSelect(selected) {
      this.selectTableData = this.selectTableData.concat(selected);
      if (this.form.categoried === 1) {
        this.handleCategories();
      }
      if (selected.length > 0) {
        this.$refs.form.clearValidate("papers");
      }
    },
    onMoveUp(index) {
      if (index > 0) {
        let prevItem = this.selectTableData[index - 1];
        this.selectTableData.splice(index - 1, 1);
        this.selectTableData.splice(index, 0, prevItem);
      }
    },
    onMoveDown(index) {
      if (index + 1 <= this.selectTableData.length - 1) {
        let nextItem = this.selectTableData[index + 1];
        this.selectTableData.splice(index + 1, 1);
        this.selectTableData.splice(index, 0, nextItem);
      }
    },
    onDeleteSelect(index, PaperCategoryID) {
      this.selectTableData.splice(index, 1);
      if (this.form.categoried === 1) {
        this.deleteCate(PaperCategoryID);
      }
    },
    deleteCate(PaperCategoryID) {
      const belongToCatesSEs = this.selectTableData.filter(
        (i) => i.PaperCategoryID === PaperCategoryID
      );
      if (belongToCatesSEs.length === 0) {
        const index = this.form.categories.findIndex(
          (i) => i.categoryId === PaperCategoryID
        );
        if (index != -1) {
          this.form.categories.splice(index, 1);
        }
      }
    },
    selectedSEValidate() {
      return (
        this.form.seIds.length > 1 &&
        this.form.seIds.some((seId) => {
          return this.seList.some((se) => se.SEID === seId && !se.Certified);
        })
      );
    },
    goToSubmit(status){
      if (this.selectedSEValidate()) {
          this.$message.error(
            "Selected HCP is currently invalid or has been transferred, please cancel your selected."
          );
          return;
        }
        let seParams = { seId: this.form.seIds[0] };
        if (this.isBatchPush) {
          seParams = { seIds: this.form.seIds };
        }
        if (this.form.categoried === 1) {
          this.form.categories.map((item, i) => {
            item.sequence = i + 1;
            return item;
          });
        }
        if(this.isVMSL) {
          this.form.meetingRequestType = this.form.requestType
        }
        this.actionDisabled = true;
        const url = this.isBatchPush ? "/push/addBatchDraft" : "/push/add";
        this.axios
          .post(url, {
            ...this.form,
            ...seParams,
            greeting: this.form.greeting.trim(),
            requestContent: this.form.requestContent.trim(),
          })
          .then(({ code, msg, data }) => {
            if (code === 200) {
              this.$emit("success");
              this.$message.success(
                status === 1 && data ? data : "Save draft successfully"
              );
              this.dialogVisible = false;
            } else if (code === 201) {
              this.dialogVisible = false;
              this.$message.error(msg);
            } else {
              this.$message.error(msg);
              this.actionDisabled = false;
            }
          })
          .catch(() => {
            this.actionDisabled = false;
          });
    },
    alertSubmit(status){
      this.$confirm('请确认推送给HCP。', '', {
              confirmButtonText: 'Submit',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(() => {
              this.goToSubmit(status);
            }).catch(() => {
              return false;
            });
    },
    submit(status) {
      this.form.status = status;
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        if(this.form.requestType === 6) {
          let noneReason = this.form.requestContent == '' || this.form.requestContent == null
          let noneActivity = this.form.initActivities.length == 0
          if(noneReason && noneActivity) {
            this.$message.error(
            "Please make sure you have input reason or check the checkbox for initiated activities"
          );
          return;
        }
        }

        if(status == 0) {
          this.goToSubmit(status);
          return;
        }
        if(this.form.requestType==5){
          //新的type需要有弹窗确认
          this.$confirm('请确认MSL发起的活动符合合理的业务目的。', '', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.alertSubmit(status);
          }).catch(() => {
            return false;
          });
        }else{
          this.alertSubmit(status);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    max-width: 90vw;
  }

  .el-dialog__body {
    padding: 0px;
    display: flex;
    max-height: 67vh;
  }
}

.el-form {
  padding: 0 30px;

  h4 {
    margin-bottom: 5px;
    white-space: nowrap;
  }

  .el-form-item {
    &.push-to-msl {
      margin-top: 28px;
      display: flex;

      ::v-deep .el-form-item__error {
        top: 90%;
        padding-top: 0;
      }

      .bind-wechat-link {
        text-decoration: underline;
        margin-left: 10px;
        color: $theme-color !important;
      }
    }

    &:not(.no-mt) {
      margin-bottom: 10px !important;
    }

    &.no-mb {
      margin-bottom: 0 !important;
    }

    ::v-deep {
      .el-form-item__label {
        padding: 0;
      }
    }

    &.cate {
      .el-radio-group {
        display: flex;
        padding: 4px 0;
      }
    }

    &.select-content {
      margin: 15px 0;
    }
  }

  .el-form-item.request-type {
    .el-radio {
      display: block;
      line-height: 32px;
    }
  }

  .el-select {
    width: 100%;
  }
}

.el-row {

  &.greetings-settings,
  &.request-type {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  &.request-type {
    h4 {
      margin-top: 5px;
      line-height: 25px;
    }

    margin-top: 10px;
    padding: 5px 0 10px;
    background-color: #f4f7f9;
  }

  .el-col {

    &.priority,
    &.schedule-date,
    &.interaction-date-time,
    &.interaction-type {
      width: auto !important;
    }

    &.priority {
      .el-form-item {
        min-width: 100px;
      }
    }

    &.interaction-type {
      .el-form-item {
        min-width: 150px;
      }
    }

    &.settings {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-right: 0 !important;

      &.msl {
        justify-content: flex-start;
      }
    }

    &.greetings {
      padding-left: 0 !important;
    }
  }

  .times-select {
    width: 110px;
  }

  .datetime {
    display: flex;
    align-items: flex-end;

    .el-date-editor {
      &:first-child {
        width: 125px !important;
      }

      &:last-child {
        width: 110px !important;
      }

      .el-input__inner {
        padding-right: 10px !important;
      }

      &:first-child {
        margin-right: 5px;
      }
    }
  }
}

.cate-intro {
  width: 455px;
  background: none;

  ::v-deep {

    th,
    tr,
    td {
      background: none !important;
    }
  }
}

.table-wrapper {
  padding: 10px 30px;

  .operation-actions {
    .el-button {
      font-size: 16px;
      color: $link-text;

      &:hover {
        color: $link-text-hover;
      }
    }
  }
}

.dialog-footer {
  text-align: center;
}
::v-deep.el-form .el-form-item.request-type .el-radio .el-radio__label{
  white-space: break-spaces;
  word-break: break-word;
  vertical-align: top;
  display: inline-block;
}
.activity_options {
  margin-top: 10px; 
  font-size: 12px; 
  display: flex; 
  flex-direction: column;
}
</style>
